<template>
  <div class="custom-player">
    <div class="video-player-container">
      <video ref="videoPlayer" class="video-player" playsinline id="videoPlayercutom"></video>
      <div v-if="!playing" class="video-placeholder" @click.stop="togglePlay"></div>

      <!-- 简化后的控制条 -->
      <div class="player-controls">
        <button class="control-btn" @click.stop="togglePlay">
          {{ playing ? '❚❚' : '▶' }}
        </button>

        <div class="play-tools">
          <!-- 倍速 -->
          <el-popover placement="top" trigger="hover" popper-class="rate-popper">
            <ul class="tools-box">
              <li
                :class="{ active: rate.value === selectedRate }"
                v-for="rate in rateOptions"
                :key="rate.value"
                @click="selectedRateFn(rate.value)"
              >
                {{ rate.label }}
              </li>
            </ul>

            <span slot="reference" v-if="this.videoType === 'history'" class="frame-rate">倍速</span>
          </el-popover>
          <!-- 垂直音量控制条 -->
          <el-popover placement="top" trigger="hover" popper-class="volume-popper">
            <input
              type="range"
              min="0"
              max="1"
              step="0.1"
              v-model="volume"
              @click.stop
              @input="changeVolume($event)"
              class="vertical-volume-slider"
              orient="vertical"
            />

            <button slot="reference" class="control-btn" @click.stop="toggleMute">
              {{ muted ? '🔇' : '🔊' }}
            </button>
          </el-popover>

          <button v-if="croping" class="control-btn el-icon-scissors" @click.stop="cropingFn"></button>
          <button class="control-btn fullscreen-btn" @click.stop="toggleFullscreen">⛶</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mpegtsjs from 'mpegts.js';
import request from '@/utils/request';
import api from '@/utils/api';
import { Message, MessageBox } from 'element-ui';
export default {
  props: {
    devNum: {
      type: String,
      default: ''
    },
    croping: {
      type: Boolean,
      default: true
    },
    videoType: {
      type: String,
      default: ''
    },
    startTime: {
      type: String,
      default: ''
    },
    endTime: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      volume: 0, // 音量
      playing: false, // 正在播放
      muted: false, // 静音
      isPlaying: false, // 判断是否正在播放直播
      notSpeedCount: 0, //记录播放速度为0的次数
      flvVideo: null, //播放器
      url: '',
      rateOptions: [
        {
          label: '2.0x',
          value: 2.0
        },
        {
          label: '1.5x',
          value: 1.5
        },
        {
          label: '1.25x',
          value: 1.25
        },
        {
          label: '1.0x',
          value: 1.0
        },
        {
          label: '0.75x',
          value: 0.75
        },
        {
          label: '0.5x',
          value: 0.5
        }
      ],
      selectedRate: 1.0
    };
  },
  mounted() {},
  async beforeDestroy() {
    await this.stopFlv();
    this.destoryVideo();
  },
  methods: {
    selectedRateFn(val) {
      this.selectedRate = val;
      this.togglePlay();
    },
    cropingFn() {
      // 获取video元素
      const videoElement = this.$refs.videoPlayer;

      // 检查视频是否已加载
      if (!videoElement || videoElement.readyState < 2) {
        this.$message.warning('视频尚未加载完成，请稍后截图');
        return;
      }

      // 创建canvas元素进行截图
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');

      // 设置canvas尺寸与视频一致
      canvas.width = videoElement.videoWidth;
      canvas.height = videoElement.videoHeight;

      // 将视频当前帧绘制到canvas上
      ctx.drawImage(videoElement, 0, 0, canvas.width, canvas.height);

      try {
        // 将canvas转换为图片数据URL
        const imageDataURL = canvas.toDataURL('image/png');
        if (imageDataURL) {
          this.$emit('setImgUrl', imageDataURL);
        }
        // 创建下载链接
        // this.downloadScreenshot(imageDataURL);
      } catch (error) {
        console.error('截图失败:', error);
        this.$message.error('截图失败，可能是跨域限制');
      }
    },
    // 下载截图
    downloadScreenshot(dataURL) {
      // 创建临时下载链接
      const link = document.createElement('a');
      const timestamp = new Date().toISOString().replace(/[:.]/g, '-');
      const filename = `screenshot-${timestamp}.png`;

      link.href = dataURL;
      link.download = filename;
      link.style.display = 'none';

      // 添加到文档并触发下载
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      this.$message.success('截图已下载');
    },
    // 获取url
    async getUrl() {
      if (!this.devNum) {
        return;
      }
      let url = `${api.monitorDashbord.getMonitVideoUrl}`;
      let params = { devNum: this.devNum };
      if (this.videoType === 'history') {
        url = `${api.monitorDashbord.getHistoryPlay}`;
        params.startTime = this.startTime;
        params.endTime = this.endTime;
        params.frameRate = this.selectedRate;
      }
      return new Promise(async (resolve, reject) => {
        try {
          const res = await request.post(`${url}`, params);
          if (res.code === 200) {
            this.url = res?.data?.playUrl || ''; // 返回视频URL
            resolve(this.url);
          } else {
            this.$message.error('获取视频流地址失败');
            this.url = '';
            reject();
          }
        } catch (error) {
          this.$message.error('获取视频流地址失败');
          this.url = '';
          reject();
        }
      });
    },
    async initVideo(url = this.url, videoId = 'videoPlayercutom') {
      if (!videoId || !url) return;
      let that = this;
      this.destoryVideo();
      const videoElement = this.$refs.videoPlayer;
      // 添加视频元素错误监听
      videoElement?.addEventListener('error', (e) => {
        that.refreshVideo(url, videoId);
      });
      let flvPlayer = mpegtsjs.createPlayer(
        {
          type: 'flv',
          url: url,
          isLive: true,
          enableStashBuffer: false,
          cors: true,
          withCredentials: false,
          hasVideo: true
        },
        {
          liveBufferLatencyChasing: true //追帧
        }
      );
      flvPlayer.attachMediaElement(videoElement);
      flvPlayer.load();
      try {
        flvPlayer.play();
        this.playing = true;
      } catch (error) {
        console.error('播放失败:', error);
        this.playing = false;
        that.refreshVideo(url, videoId);
        return;
      }
      this.flvVideo = flvPlayer;
      //监听播放器发生错误
      flvPlayer.on(mpegtsjs.Events.ERROR, (errorType, errorDetail, errorInfo) => {
        console.log('类型:' + errorType, '报错内容' + errorDetail, '报错信息' + JSON.stringify(errorInfo));
      });
      //监听播放信息，该方法会持续调用
      flvPlayer.on(mpegtsjs.Events.STATISTICS_INFO, (e) => {
        //当播放速度为0时，记录一下为0的次数，达到一定次数时，刷新播放器，重新拉取视频流；偶尔卡顿一下不用处理，这里要处理的是长时间拉取不到流，防止链接断开
        if (e.speed == 0) {
          console.log('直播信息：' + JSON.stringify(e));
          if (that.notSpeedCount > 10) {
            that.notSpeedCount = 0;
            that.refreshVideo(url, videoId);
            that.isPlaying = false;
          } else {
            that.notSpeedCount += 1;
          }
        } else {
          if (!that.isPlaying) {
            that.isPlaying = true;
            flvPlayer.play();
          }
          that.notSpeedCount = 0;
        }
      });
    },
    //销毁
    destoryVideo() {
      if (this.flvVideo) {
        this.flvVideo.pause();
        this.flvVideo.unload();
        this.flvVideo.detachMediaElement();
        this.flvVideo.destroy();
        this.flvVideo = null;
      }
    },
    //刷新播放器
    refreshVideo(url = this.url, videoId = 'videoPlayercutom') {
      if (!url || !videoId) return;
      this.destoryVideo();
      setTimeout(() => {
        this.initVideo(url, videoId);
      }, 500);
    },
    async togglePlay() {
      const videoElement = this.$refs.videoPlayer;
      if (!videoElement) {
        return;
      }

      if (this.playing) {
        // 暂停播放
        videoElement.pause();
        await this.stopFlv();
        if (this.flvVideo) {
          this.flvVideo.pause();
        }
        this.playing = false;
      } else {
        this.destoryVideo();
        await this.getUrl();
        this.initVideo();
        this.playing = true;
      }
    },
    // 停止推送流
    stopFlv() {
      if (!this.devNum) {
        return;
      }
      let url = `${api.monitorDashbord.stopPlay}`;
      let params = { devNum: this.devNum };
      if (this.videoType === 'history') {
        url = `${api.monitorDashbord.stopHistoryPlay}`;
        params.startTime = this.startTime;
        params.endTime = this.endTime;
      }
      return new Promise(async (resolve, reject) => {
        try {
          const res = await request.post(url, params);
          if (res.code === 200) {
            resolve(true);
          } else {
            this.$message.error('暂停失败');
            reject(false);
          }
        } catch (error) {
          this.$message.error('暂停失败');
          reject(false);
        }
      });
    },
    changeVolume(event) {
      const volume = parseFloat(event.target.value);
      this.volume = volume;
      const videoElement = this.$refs.videoPlayer;
      if (videoElement) {
        videoElement.volume = volume;
        // 如果音量大于0，且当前是静音状态，则取消静音
        if (volume > 0 && this.muted) {
          this.muted = false;
          videoElement.muted = false;
        }
        // 如果音量等于0，且当前不是静音状态，则静音
        if (volume === 0 && !this.muted) {
          this.muted = true;
          videoElement.muted = true;
        }
      }
    },
    toggleMute() {
      this.muted = !this.muted;
      const videoElement = this.$refs.videoPlayer;
      if (videoElement) {
        videoElement.muted = this.muted;
        // 如果取消静音，且当前音量为0，则恢复之前的音量（但之前没有记录，所以我们可以用this.volume）
        // 但是，如果我们静音时，音量滑块为0，那么取消静音时，我们需要将音量设置为非0？不对，因为静音时音量滑块可能是0，但非静音时我们希望恢复到之前的音量。
        // 所以我们需要一个变量来记录非静音时的音量。
        if (!this.muted) {
          // 取消静音：将音量设置为之前记录的音量
          this.volume = this.previousVolume;
          videoElement.volume = this.volume;
        } else {
          // 静音：记录当前音量，然后将音量设置为0
          this.previousVolume = this.volume;
          this.volume = 0;
          videoElement.volume = 0;
        }
      }
    },
    toggleFullscreen() {
      const videoContainer = this.$refs.videoPlayer.parentElement;
      if (!document.fullscreenElement) {
        if (videoContainer.requestFullscreen) {
          videoContainer.requestFullscreen();
        } else if (videoContainer.mozRequestFullScreen) {
          videoContainer.mozRequestFullScreen();
        } else if (videoContainer.webkitRequestFullscreen) {
          videoContainer.webkitRequestFullscreen();
        } else if (videoContainer.msRequestFullscreen) {
          videoContainer.msRequestFullscreen();
        }
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.custom-player {
  margin-bottom: 15px;
  background-color: #000;
  width: 100%;
  height: 100%;
  overflow: hidden;
  border-radius: 8px;
}
.video-player-container {
  width: 100%;
  height: 100%;
  position: relative;

  .video-placeholder {
    width: 108px;
    height: 108px;
    background: url('@/assets/images/start.png') no-repeat center center;

    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .video-player {
    position: absolute;
    width: 100%;
    height: 100%;
    right: 0;
    padding: 0 1px;
  }

  &:hover {
    .player-controls {
      opacity: 1;
    }
  }
}

.control-btn {
  background: none;
  border: none;
  color: white;
  cursor: pointer;
  font-size: 16px;
  margin: 0 15px;
  padding: 5px;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  transition: background 0.2s;

  &:hover {
    background: rgba(255, 255, 255, 0.3);
  }

  &.fullscreen-btn {
  }
}

.vertical-volume-slider {
  -webkit-appearance: none;
  width: 6px;
  height: 100px;
  background: linear-gradient(to top, #4a90e2, #1ecb80); /* 渐变轨道，从下到上 */
  border-radius: 3px;
  outline: none;
  opacity: 1;
  transform: rotate(0deg); /* 不需要旋转180度了 */
  writing-mode: bt-lr;
  -webkit-appearance: slider-vertical;

  /* 滑块手柄样式 */
  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background: white;
    cursor: pointer;
    margin-top: -8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
    transition: transform 0.2s;

    &:hover {
      transform: scale(1.2);
    }
  }
}

.player-controls {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
  opacity: 0;
  padding: 10px;
  background: rgba(0, 0, 0, 0.7);
  color: white;
  transition: opacity 0.3s;
  z-index: 10;

  .play-tools {
    display: flex;
    align-items: center;

    .frame-rate {
      color: #fff;
      cursor: pointer;
      font-weight: 600;
      white-space: nowrap;
      width: 100%;
      font-size: 14px;
    }
  }
}

.tools-box {
  background-color: hsla(0, 0%, 8%, 0.9);
  border-radius: 2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  text-align: center;
  width: 70px;
  margin: 0;
  padding: 0;

  li {
    color: #fff;
    cursor: pointer;
    height: 22px;
    line-height: 22px;
    list-style: none;

    &.active {
      color: #366bfc;
    }
    &:hover {
      background-color: hsla(0, 0%, 100%, 0.1);
    }
  }
}
</style>
<style lang="scss">
.rate-popper.el-popper {
  min-width: 0 !important;
  width: auto;
  background-color: hsla(0, 0%, 8%, 0.9);
  border: none;
  padding: 0;
  margin: 0;
  margin-bottom: 10px;
  .popper__arrow {
    display: none;
  }
}
</style>
